import clsx from "clsx";
import React from "react";

export interface IStatsCardsSkeletonProps {
  cardCount?: number;
  className?: string;
}

const StatsCardsSkeleton: React.FC<IStatsCardsSkeletonProps> = ({ cardCount = 6, className }) => {
  return (
    <div
      className={clsx(
        "flex w-full gap-3 py-0 animate-pulse overflow-x-auto lg:gap-[20px]",
        className,
      )}
    >
      {Array.from({ length: cardCount }).map((_, idx) => (
        <div
          key={idx}
          className="flex h-[84px] min-w-[10rem] flex-none flex-col justify-center gap-[10px] rounded-[10px] border border-[#E6E7EB] bg-white px-3 lg:min-w-0 lg:flex-1"
        >
          <div className="h-5 w-8 rounded bg-gray-200" />
          <div className="h-3 w-24 rounded bg-gray-200" />
        </div>
      ))}
    </div>
  );
};

export default StatsCardsSkeleton;
